import React from 'react'
import Button from './Button'

const ButtonIconDownload = (props) => {
  return (
    <Button
      icon="download"
      {...props}
    />
  )
}

export default ButtonIconDownload
